export default () => {
  const getBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      // We know the result is a string because we're using FileReader.readAsDataURL.
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const base64ToBlob = (base64: string, contentType: string): Blob => {
    // Convert Base64 string to a byte array
    const byteCharacters = atob(base64.replace(/^data:.+;base64,/, ''));
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    // Create the Blob from the byte arrays
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  return { getBase64, base64ToBlob };
};
